var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg25Stats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 93.5,
    fill: "#99309B",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4062 94.3902C50.4062 91.5252 52.7292 89.2021 55.5942 89.2021C58.4592 89.2021 60.7822 91.5252 60.7822 94.3902C60.7822 97.2552 58.4592 99.5782 55.5942 99.5782C52.7292 99.5782 50.4062 97.2552 50.4062 94.3902Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.346 94.3902C103.346 91.5252 105.669 89.2021 108.534 89.2021C111.399 89.2021 113.722 91.5252 113.722 94.3902C113.722 97.2552 111.399 99.5782 108.534 99.5782C105.668 99.5782 103.346 97.2552 103.346 94.3902Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2266 122.739L50.4056 108.061L42.5846 122.739C41.3136 125.082 40.6816 126.34 40.6816 128.499C40.6816 133.869 45.0346 138.222 50.4046 138.222C55.7746 138.222 60.1276 133.869 60.1276 128.499C60.1296 126.34 59.6296 125.43 58.2266 122.739Z",
    stroke: "white",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4922 117.879C70.3042 114.804 76.0222 113.022 82.1562 113.022C89.0472 113.022 95.4142 115.272 100.56 119.076",
    stroke: "white",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25Stats);
export default __webpack_public_path__ + "static/media/25-stats.6d51e79810e6ba1467394851063db6ad.svg";
export { ForwardRef as ReactComponent };